import React, { useState } from 'react';
import { IconButton, Tooltip, Snackbar, Alert, CircularProgress } from '@mui/material';
import { Sync as SyncIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { userService } from '../../services/user.service';

// Pulls the last 48h of Strava activities and reports how many were imported.
export const StravaSyncButton = ({ size = 28 }: { size?: number }) => {
  const { t } = useTranslation('layout');
  const [syncing, setSyncing] = useState(false);
  const [result, setResult] = useState<{ ok: boolean; text: string } | null>(null);

  const sync = async () => {
    setSyncing(true);
    try {
      const res = await userService.syncStravaActivities();
      const { syncedCount = 0, skippedCount = 0 } = res.data;
      setResult({ ok: true, text: skippedCount
          ? t('strava.syncedWithSkipped', { count: syncedCount, skipped: skippedCount })
          : t('strava.synced', { count: syncedCount }) });
    } catch (err: any) {
      setResult({ ok: false, text: err?.response?.data?.message || t('strava.syncFailed') });
    } finally {
      setSyncing(false);
    }
  };

  return (
    <>
      <Tooltip title={t('strava.syncNow')}>
        <span>
          <IconButton
            onClick={sync}
            disabled={syncing}
            aria-label={t('strava.syncNowAria')}
            sx={{ width: size, height: size, border: '1px solid var(--border)', borderRadius: '7px', backgroundColor: 'var(--card)', color: 'var(--fg)' }}
          >
            {syncing ? <CircularProgress size={12} /> : <SyncIcon sx={{ fontSize: 15 }} />}
          </IconButton>
        </span>
      </Tooltip>
      <Snackbar open={!!result} autoHideDuration={4000} onClose={() => setResult(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert severity={result?.ok ? 'success' : 'error'} onClose={() => setResult(null)} variant="filled">
          {result?.text}
        </Alert>
      </Snackbar>
    </>
  );
};
